import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NavController,
  NavParams,
  ModalController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html/safe-html';
import { QuillModule } from 'ngx-quill';
@Component({
  selector: 'app-editor-html',
  templateUrl: './editor-html.page.html',
  styleUrls: ['./editor-html.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SafeHtmlPipe,
    TranslateModule,
    QuillModule,
  ],
})
export class EditorHtmlPage implements OnInit {
  text = '';
  titulo = '';
  readOnly = false;
  justText = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController
  ) {
    this.text = this.navParams.get('html');
    this.titulo = this.navParams.get('titulo');
    this.readOnly = this.navParams.get('readOnly');
    this.justText = this.navParams.get('justText');
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }

  salvarHtml() {
    this.modalCtrl.dismiss(this.text);
  }
}
